const NEW = 'New';
const PROCESSING = 'Processing'; // Removed hyphen for consistency
const DELIVERING = 'Delivering';
const COMPLETED = 'Completed';
const CANCELLED = 'Cancelled';

export { NEW, PROCESSING,DELIVERING, COMPLETED, CANCELLED };